import React from 'react';

// Atomic-age four-point sparkle taken from the 2026 Lancers menu badge.
// Wide horizontal diamond with concave edges — drawn as four quadratic curves.
export default function Star ({className = "", color = "currentColor", title}) {
  return (
    <svg
      className={"lancers-star " + className}
      viewBox="0 0 204 69"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : "true"}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      <path
        fill={color}
        d="M102 0
           Q110 26 204 34.5
           Q110 43 102 69
           Q94 43 0 34.5
           Q94 26 102 0 Z"
      />
    </svg>
  );
}
